export default __webpack_public_path__ + "static/media/CHF.8e93db6e.png";